import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import PainPoints from "./PainPoints";
import SocialProof from "./SocialProof";
import AgentSystem from "./AgentSystem";
import TrainingSection from "./TrainingSection";
import PricingValue from "./PricingValue";
import Timeline from "./Timeline";
import Guarantees from "./Guarantees";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

const LandingPage = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      <Header />
      <Hero />
      <PainPoints />
      <SocialProof />
      <AgentSystem />
      <TrainingSection />
      <PricingValue />
      <Timeline />
      <Guarantees />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;